const MWS_TOKEN_MIN_LENGTH = 20;

export default MWS_TOKEN_MIN_LENGTH;
